import { Link } from "react-router-dom";

export default function CtaBand() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="relative overflow-hidden rounded-lg">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20editorial%20backdrop%20with%20layered%20amber%20and%20deep%20olive%20tones%2C%20soft%20diagonal%20light%20bands%20and%20gentle%20gradient%20texture%2C%20premium%20magazine%20aesthetic%2C%20no%20people%2C%20minimal%20clean%20composition%20with%20generous%20negative%20space&width=1600&height=700&seq=guatian-cta-01&orientation=landscape"
          alt="看料吃瓜社线索征集背景图"
          title="看料吃瓜 - 线索投稿与瓜报订阅"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/75 to-foreground-950/60"></div>
        <div className="relative px-6 py-12 md:px-12 md:py-16 lg:max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs font-label text-accent-300 mb-4">
            <i className="ri-megaphone-line"></i>
            线索征集进行中
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 leading-tight">
            手上有值得整理的线索？交给看料吃瓜社
          </h2>
          <p className="mt-4 text-sm md:text-base text-background-200/90 leading-relaxed max-w-xl">
            写明事件大致时间、涉及的信息来源，以及可供核实的公开链接即可。我们会先做基础核实，再决定是否整理发布，并在文末标注信息来源。
          </p>
          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-label font-medium rounded-md bg-accent-500 text-foreground-950 hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-send-plane-line"></i>
              提交线索
            </Link>
            <Link
              to="/topics"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-label font-medium rounded-md bg-background-50/10 border border-background-50/30 text-background-50 hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-compass-3-line"></i>
              先逛逛专题
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}